// extracted by mini-css-extract-plugin
export default {"Insights":"IGM_Insights__cv2VI","Box":"IGM_Box__56911","Middle":"IGM_Middle__WSswQ","Left":"IGM_Left__Mtzll","Progress":"IGM_Progress__f29ar","TextMuted":"IGM_TextMuted__L0tKp"};